const DEFAULT_BG_INDEX = 0;

const HERO_IMAGES = [
    {
        title: 'fashion_designer',
        name: 'Andrea',
        className: 'hero-andrea',
        showStars: false
    },
    {
        title: 'marketing_expert',
        name: 'Moon',
        className: 'hero-moon',
        showStars: true
    },
    {
        title: 'shoemaker_and_designer',
        name: 'Ritika',
        className: 'hero-ritika',
        showStars: false
    },
    {
        title: 'bar_owner',
        name: 'Zach',
        className: 'hero-zach',
        showStars: false
    },
    {
        title: 'video_editor',
        name: 'Gabrielle',
        className: 'hero-gabrielle',
        showStars: true
    }
];

module.exports = {
    DEFAULT_BG_INDEX,
    HERO_IMAGES
};
